import { FeatureChargesTable as AntdFeatureChargesTable } from "@empglabs/backoffice-ui-kit"

const FeatureChargesTable = props => {
  return <AntdFeatureChargesTable {...props} />
}

export default FeatureChargesTable
